import React, { useContext, useEffect } from 'react';
import { StepButtonArrowLongIcon } from '../../assets/icons';
import tableContext from './tableContext';

type Props = {
    rowPerPage?: number;
};

const Pagination: React.FC<Props> = ({ rowPerPage = 5 }) => {
    const {
        dataLength,
        initialDataLength,
        prevPage,
        curPage,
        setCurPage,
        setPrevPage,
        setPagination,
    } = useContext(tableContext);

    const hasPrevious = curPage > 1;
    const hasNext = curPage < Math.ceil(dataLength / rowPerPage);

    const prev = (curPage: number) => {
        if (hasPrevious) {
            const page = curPage - 1;

            setCurPage(page);
            if (initialDataLength === dataLength) {
                setPrevPage(page); // used to track page user was at before data length changes
            }
        }
    };

    const next = (curPage: number) => {
        if (hasNext) {
            const page = curPage + 1;

            setCurPage(page);
            if (initialDataLength === dataLength) {
                setPrevPage(page); // used to track page user was at before data length changes
            }
        }
    };

    useEffect(() => {
        setPagination(true, rowPerPage);
    }, [rowPerPage, setPagination]);

    useEffect(() => {
        if (initialDataLength === dataLength && prevPage) {
            setCurPage(prevPage);
            return;
        }

        setCurPage(1);
    }, [initialDataLength, dataLength, prevPage, setCurPage]);

    return (
        <div className='pagination'>
            <div
                className={`prev ${!hasPrevious ? 'disabled' : ''}`}
                onClick={() => prev(curPage)}
            >
                <StepButtonArrowLongIcon />
            </div>
            <div className='paginate'>
                {dataLength ? curPage : 0} of{' '}
                {dataLength ? Math.ceil(dataLength / rowPerPage) : 0}
            </div>
            <div
                className={`next ${!hasNext ? 'disabled' : ''}`}
                onClick={() => next(curPage)}
            >
                <StepButtonArrowLongIcon />
            </div>
        </div>
    );
};

Pagination.displayName = 'Pagination';

export default Pagination;
